module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Bet Sizing Calculator")]), _vm._v(" "), _c('div', {
    staticClass: "two-column"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('bankroll')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("\n              Please enter a bankroll\n            ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('odds')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('odds')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('edge')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('edge')) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "bankroll"
    }
  }, [_vm._v("Bankroll:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankroll),
      expression: "bankroll"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "bankroll",
    attrs: {
      "type": "number",
      "name": "bankroll"
    },
    domProps: {
      "value": _vm._s(_vm.bankroll)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankroll = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "odds"
    }
  }, [_vm._v("American Odds:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odds),
      expression: "odds"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|american_odds'),
      expression: "'required|american_odds'"
    }],
    ref: "odds",
    attrs: {
      "type": "text",
      "name": "odds",
      "data-vv-delay": "4000"
    },
    domProps: {
      "value": _vm._s(_vm.odds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.odds = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "risk"
    }
  }, [_vm._v("Edge %:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edge),
      expression: "edge"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    ref: "edge",
    attrs: {
      "type": "number",
      "name": "edge"
    },
    domProps: {
      "value": _vm._s(_vm.edge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edge = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "radio-group"
  }, _vm._l((_vm.multipliers), function(multiplier) {
    return _c('div', {
      key: multiplier
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMultiplier),
        expression: "selectedMultiplier"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": multiplier,
        "checked": _vm._q(_vm.selectedMultiplier, multiplier)
      },
      on: {
        "change": _vm.multiplierChange,
        "click": function($event) {
          _vm.selectedMultiplier = multiplier
        }
      }
    }), _vm._v("\n                    " + _vm._s(multiplier) + "\n                  ")])])
  }))]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "big-btn grey",
    attrs: {
      "type": "submit",
      "value": "Calculate Optimal Bet Size",
      "name": "submitButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.calculate($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column",
    staticStyle: {
      "min-width": "100px"
    }
  }, [(_vm.showOptimalBetSize) ? _c('h4', [_vm._v("\n            Optimal Bet Size: $" + _vm._s(_vm.optimal.betSize) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showOptimalBetSize) ? _c('p', [_vm._v("\n            It is recommended that you bet approximately "), _c('b', [_vm._v(_vm._s(_vm.optimal.percentage))]), _vm._v(" of your bankroll on this particular selection.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showOptimalBetSize) ? _c('p', [_c('b', [_vm._v("Note:")]), _vm._v(" This is a general recommendation for " + _vm._s(_vm.selectedMultiplier) + " bet sizing and should be adjusted based on your own risk tolerance and confidence in the selection.\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7997332272",
      "ad-style": "display:inline-block;width:250px;height:250px",
      "ad-format": "auto"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e5a1731!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tools/BetSizing.vue
// module id = 490
// module chunks = 1